import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { localNum } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg, chunkTransformations } from "@faire/web--source/ui/lib/localization";
import React, { useState } from "react";
import { useFirstOrderIncentiveTimeRemaining } from "@faire/retailer/hooks/firstOrderIncentive/useFirstOrderIncentiveTimeRemaining";
import { useInsiderMembershipInformation } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderMembershipInformation";
import { LazyAutoEnrollModal } from "./LazyAutoEnrollModal";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
export var InsiderAutoEnrollBanner = function() {
    var _useState = _sliced_to_array(useState(false), 2), isModalShowing = _useState[0], setIsModalShowing = _useState[1];
    var _useInsiderMembershipInformation = useInsiderMembershipInformation(), insiderMembershipInformation = _useInsiderMembershipInformation.insiderMembershipInformation, isInsiderMembershipInformationFetching = _useInsiderMembershipInformation.isInsiderMembershipInformationFetching;
    var _insiderMembershipInformation_current_period_end_at;
    var _useFirstOrderIncentiveTimeRemaining = useFirstOrderIncentiveTimeRemaining((_insiderMembershipInformation_current_period_end_at = insiderMembershipInformation === null || insiderMembershipInformation === void 0 ? void 0 : insiderMembershipInformation.current_period_end_at) !== null && _insiderMembershipInformation_current_period_end_at !== void 0 ? _insiderMembershipInformation_current_period_end_at : 0), daysRemaining = _useFirstOrderIncentiveTimeRemaining.daysRemaining, hoursRemaining = _useFirstOrderIncentiveTimeRemaining.hoursRemaining;
    var daysLeftNumber = localNum(daysRemaining);
    var onViewDetailClick = function() {
        setIsModalShowing(true);
    };
    var hideModal = function() {
        setIsModalShowing(false);
    };
    var getBannerText = function() {
        if (hoursRemaining < 24) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "P8UeHN",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Last day to save!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Free shipping with thousands of brands available with your welcome offer."
                    }
                ],
                values: {
                    MediumFormatting: chunkTransformations.Medium
                }
            });
        } else if (daysRemaining <= 7) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "4Hrxdg",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Only "
                            },
                            {
                                type: 1,
                                value: "daysLeftNumber"
                            },
                            {
                                type: 0,
                                value: " days left!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Free shipping with thousands of brands available with your welcome offer."
                    }
                ],
                values: {
                    MediumFormatting: chunkTransformations.Medium,
                    daysLeftNumber: daysLeftNumber
                }
            });
        } else {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "4GLX4I",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Free shipping with thousands of brands!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Available with your welcome offer."
                    }
                ],
                values: {
                    MediumFormatting: chunkTransformations.Medium
                }
            });
        }
    };
    if (isInsiderMembershipInformationFetching) {
        return /*#__PURE__*/ _jsx(LoadingSpinner, {});
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                align: "center",
                "data-test-id": "insider-auto-enroll-banner",
                children: [
                    getBannerText(),
                    " ",
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        onClick: onViewDetailClick,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "CUt5kf",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "View details"
                                }
                            ]
                        })
                    })
                ]
            }),
            isModalShowing ? /*#__PURE__*/ _jsx(LazyAutoEnrollModal, {
                onCloseModal: hideModal
            }) : null
        ]
    });
};
